import { cn } from "@moe/priv/utils";
import { useQuery } from "@tanstack/react-query";
import { FeaturedCard } from "@web/route-services/index/FeaturedCard";
import { useAppContext } from "@web/route-services/root/AppContext";
import { Carousel } from "./Carousel";

interface FeaturedProps {
  className?: string;
}

export function Featured({ className }: FeaturedProps) {
  const { session, access, settings } = useAppContext();

  // Like status for this query is dependent on if the user is authenticated
  // We must invalidate when the user id changes
  const { data: chars, isPending } = useQuery({
    queryKey: ["get-featured-chars", session?.user.id, settings?.nsfwOK, settings?.blacklistedTags],
    queryFn: async () => {
      let chars = await access.character.getFeatured({
        nsfwOK: settings?.nsfwOK
      });
      // Shuffle the characters
      chars = chars.sort(() => Math.random() - 0.5);

      // Filter out blacklisted tags
      if (settings?.blacklistedTags) {
        chars = chars.filter((char) => !char.tags?.some((tag) => settings.blacklistedTags.includes(tag)));
      }
      return chars;
    }
  });
  const renderItem = (char: any) => <FeaturedCard char={char} isPending={isPending} />;
  const itemKeyFn = (char: any, index: number) => char?.id ?? index;

  return (
    <div className={cn("mx-2 flex flex-col space-y-2 md:mx-0", className)}>
      <div className="text-tx-primary text-2xl font-semibold md:text-3xl">{"🌟 Featured"}</div>
      {chars && <Carousel items={chars} renderItem={renderItem} itemKeyFn={itemKeyFn} />}
      {!chars && isPending && (
        <Carousel items={Array.from({ length: 6 })} renderItem={renderItem} itemKeyFn={itemKeyFn} />
      )}
    </div>
  );
}
